import { createContext, useMemo, useState } from "react";

interface ScrollContainerContextValue {
  scrollContainer: React.RefObject<HTMLDivElement> | null;
  setScrollContainer: (state: React.RefObject<HTMLDivElement>) => void;
}

export const ScrollContainerContext =
  createContext<ScrollContainerContextValue>({} as ScrollContainerContextValue);

export const ScrollContainerProvider: React.FC = ({ children }) => {
  const [scrollContainer, setScrollContainer] =
    useState<React.RefObject<HTMLDivElement> | null>(null);

  const value = useMemo(
    () => ({ scrollContainer, setScrollContainer }),
    [scrollContainer]
  );

  return (
    <ScrollContainerContext.Provider value={value}>
      {children}
    </ScrollContainerContext.Provider>
  );
};
